import { Injectable } from '@angular/core';
import { companyConfigService } from './core/services/company-config.service';
import { HttpClient } from '@angular/common/http';
import { catchError, firstValueFrom, forkJoin, map, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppConstants_settings } from './core/AppConstants_Appsettings.enum';
import { ICompanyconfigModel } from './models/config-model';
import { ApiService } from './core/services/api.service';
import { IndexedDbService } from './core/services/indexed-dbservice.service';
import { CurrencySettingsService } from './core/services/currency-setting.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  private _initPromise: Promise<void> | null = null;

  configmodel: ICompanyconfigModel = {
    CompanyConfig: {},
    DBConfig: {},
    GuestToken: {}
  };

  compId: any;

  constructor(
    private http: HttpClient,
    private companyConfigService: companyConfigService,
    private store: Store,
    private api: ApiService,
    private dbService: IndexedDbService,
    private currencySettings: CurrencySettingsService,
    private cookieService: CookieService,
    private router: Router
  ) { }

  async init(): Promise<void> {

    if (this._initPromise) {
      return this._initPromise;
    }

    this._initPromise = (async () => {
      try {

        const dbConfig = await firstValueFrom(
          this.http.get(
            environment.BACKOFFICE_URL + '/Login/GetWebsiteData'
          ).pipe(
            catchError(() => of(null))
          )
        );

        let matchedConfig = (dbConfig as any[])?.find(x =>
          x.url?.includes(window.location.origin)
        );

        this.compId = matchedConfig?.companyId || 'NS';

        const params = new URLSearchParams(window.location.search);
        let token = params.get('token');
        let activeid = params.get('activeid');

        if (!token && sessionStorage.getItem('isB2BMode') === 'true') {
          token = this.cookieService.get('B2Btoken');
          activeid = sessionStorage.getItem('activeBocId');
        }

        if (token) {
          sessionStorage.setItem('isB2BMode', 'true');
          if (activeid) {
            sessionStorage.setItem('activeBocId', activeid);
          }

          let expTime = Date.now() + 3600 * 1000;
          try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            await this.dbService.setData("tokenData", payload);
            if (payload.exp) {
              expTime = payload.exp * 1000;
            }
          } catch (e) {
            console.error('Error parsing token:', e);
          }

          const userInfo = {
            token: token,
            tokenExpTime: expTime,
            lastActivityTime: Date.now()
          };
          this.cookieService.set('B2Btoken', token, { path: '/', sameSite: 'Lax' });
          await this.dbService.setData('userInfo', userInfo);

          if (params.get('token')) {
            setTimeout(() => {
              this.router.navigate(['/flight']);
            }, 100);
          }
        }

        if (sessionStorage.getItem('isB2BMode') === 'true') {
          (AppConstants_settings as any).CHANNEL = 'BOA';
          const savedActiveId = sessionStorage.getItem('activeBocId');
          if (savedActiveId) {
            (AppConstants_settings as any).ActiveBOC_ID = savedActiveId;
          }
        } else {
          (AppConstants_settings as any).CHANNEL = matchedConfig?.urlType || 'B2B';
        }
        (AppConstants_settings as any).COMPANY_ID = this.compId;
        console.log((AppConstants_settings as any).COMPANY_ID);

        const { companyConfig } = await firstValueFrom(
          forkJoin({
            companyConfig: this.api.companySettings(this.compId).pipe(
              map((res: any) =>
                res?.jsondata ? JSON.parse(res.jsondata) : null
              ),
              catchError(() => of(null))
            ),
          })
        );

        if (dbConfig) {
          this.companyConfigService.setDbConfig(dbConfig);
        }

        if (companyConfig) {
          this.companyConfigService.setCompanyConfig(companyConfig);
          this.dbService.setData('websiteSetting', companyConfig);
        }

        // if (GuestToken) {
        //   this.companyConfigService.setGuestToken(GuestToken);
        //   let token = JSON.parse(JSON.stringify(GuestToken))?.guesttoken;
        //   if (token) {
        //     this.cookieService.set('guestToken', token, {
        //       path: '/',
        //       sameSite: 'Lax'
        //     });
        //   }
        // }

      } catch {
        return;
      }
    })();

    return this._initPromise;
  }
}
